import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_plus_size: FaireCategoryEntity = {
  token: "cat_women-plus-size",
  type: "category",
  name: "Plus size",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/plus-size",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
